var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWhole({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "#A1A5B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 10.4L15.8 6.4L16.8892 5.17007C17.1826 4.83879 17.5366 4.56665 17.9322 4.36831L18.4213 4.12303C18.5827 4.04213 18.7607 4 18.9411 4H19.3298C19.5973 4 19.8347 4.1713 19.9191 4.42515C19.9709 4.58104 19.9588 4.75112 19.8855 4.89814L19.5556 5.56L18.2222 7.56571L16.8 9.8L15.2 12.2457L13.8 14.4L11 18.6L10.2 19.6C9.97429 19.8257 9.61286 19.8396 9.3705 19.6319L9.33333 19.6C9.03752 19.3033 8.76613 18.9833 8.5218 18.643L4.88889 13.5829L4.20455 12.5534C4.07424 12.3574 4.03244 12.1156 4.08937 11.8872C4.17004 11.5636 4.435 11.3187 4.76393 11.2637L5.05948 11.2143C5.37857 11.161 5.70608 11.2291 5.97747 11.4052L9.25212 13.5302C9.2989 13.5605 9.3608 13.5524 9.39812 13.5109L12.2 10.4Z",
    fill: "#26B01A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhole);
export default __webpack_public_path__ + "static/media/whole.fadcca4d.svg";
export { ForwardRef as ReactComponent };